import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Contact.scss";
import { AiFillGithub } from "react-icons/ai";
import { SiUpwork } from "react-icons/si";
import { BsLinkedin } from "react-icons/bs";
import contact from "./../../assets/hand.jpeg";
import Swal from "sweetalert2";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_yj0mexm",
        "template_z7rscus",
        form.current,
        "X1mmuZJfOi5HelhWV"
      )
      .then(
        (result) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Email has been send",
            showConfirmButton: false,
            timer: 1500,
          });
         
        },
        (error) => {
          
        }
      );
    e.target.reset();
  };

  return (
    <div className="contact flex flex-col items-center justify-center min-h-screen py-20">
      <div className="flex flex-col items-center justify-center">
        <span className="animate-charcter">Send me a</span>
        <span className="animate-charcter">message</span>
      </div>

      <div className="flex lg:flex-row md:flex-col sm:flex-col smm:flex-col justify-center items-center m-10">
        {/* COMPONENT CODE */}
        {/* Template  */}
        <div data-aos="zoom-in-right" className="bg-red-400 glass p-5 m-5">
          <div className="flex flex-col text-white">
            <img className=" rounded-lg" src={contact} alt="" />
            <div className="te text-purple-100">
              <p className="text-3xl pt-10">MD Rokibul Islm</p>
              <p className="special-text text-3xl font-bold">
                Front-end Developer | MERN Stack Developer
              </p>
              <br />
              <p>
                I am avilable for{" "}
                <b>
                  <i>Remote JOB</i>
                </b>{" "}
                &{" "}
                <b>
                  <i className="">Freelancing Work</i>
                </b>
              </p>
              <br />
              <p className="space-x-2">
                <span className="font-bold">Phone:</span>
                <span>+880-161225141</span>
              </p>
              <p className="space-x-2">
                <span className="font-bold">email:</span>
                <span>rokibul.islam0111@gmail.com</span>
              </p>
              <p className="space-x-2">
                <span className="font-bold">Whatsapp:</span>
                <span>+880-1612225141</span>
              </p>
            </div>

            <div class="flex my-4 w-2/3 lg:w-1/2 space-x-3">
              <a
                target="_blank"
                href="https://www.upwork.com/freelancers/~0111c5886bc961cace"
              >
                <div className="form-icon text-2xl">
                  <SiUpwork />
                </div>
              </a>
              <a target="_blank" href="https://github.com/rokibulslam">
                <div className="form-icon text text-2xl">
                  <AiFillGithub />
                </div>
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/rokibulslam/"
              >
                <div className=" form-icon text-2xl">
                  <BsLinkedin />
                </div>{" "}
              </a>
            </div>
          </div>
        </div>
        {/* Template End  */}
        {/* Form  */}
        <form
          data-aos="zoom-in-right"
          ref={form}
          onSubmit={sendEmail}
          className="w-full p-6 mx-3  lg:w-9/12 lg:pl-20 lg:pr-20 rounded-2xl shadow-2xl glass"
        >
          <div className="grid lg:gap-5 md:grid-cols-2 mt-5 ">
            <input
              className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none  hover:ring-2 ring-green-400"
              type="text"
              placeholder="Name*"
              name="user_name"
              required
            />
            <input
              className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none  hover:ring-2 ring-green-400"
              type="email"
              placeholder="Email*"
              name="user_email"
              required
            />
          </div>
          <div className="my-4">
            <textarea
              name="message"
              placeholder="Message*"
              class="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none  hover:ring-2 ring-green-400"
            ></textarea>
          </div>
          <div className="my-2 w-1/2 lg:w-1/4">
            <button
              className="uppercase text-sm font-bold tracking-wide bg-green-500 text-black hover:text-white  p-3 rounded-lg w-full 
                      focus:outline-none focus:shadow-outline"
            >
              Send Message
            </button>
          </div>
        </form>
        {/* Form End  */}
      </div>
    </div>
  );
};

export default Contact;
